import { i18n as I18nType } from 'i18next';

import screens from 'constants/screens';
import { folderContentIcons } from 'modules/dashboard/constants/foldersContentType';

import { AnalyticsRow } from '../utils/formatEventRow';

const analyticsTableColumns = (i18n: I18nType) => [
  {
    name: i18n.t('ColumnPartner'),
    selector: (row: AnalyticsRow) => row.partnerLabel,
    sortable: true,
    grow: 2,
    cell: (row: AnalyticsRow) => (
      <div className="user-card">
        <div className="user-info">
          <span className="tb-lead">{row.partnerLabel}</span>
          {row.partnerEmail && (
            <span className="sub-text">{row.partnerEmail}</span>
          )}
        </div>
      </div>
    ),
    export: true,
  },
  {
    name: i18n.t('ColumnAction'),
    selector: (row: AnalyticsRow) => row.actionLabel,
    sortable: true,
    cell: (row: AnalyticsRow) => row.actionLabel,
    export: true,
  },
  {
    name: i18n.t('ColumnSection'),
    selector: (row: AnalyticsRow) => row.sectionTitle,
    sortable: true,
    hide: screens.MD,
    cell: (row: AnalyticsRow) => row.sectionTitle,
    export: true,
  },
  {
    name: i18n.t('ColumnFolder'),
    selector: (row: AnalyticsRow) => row.folderTitle,
    sortable: true,
    hide: screens.SM,
    cell: (row: AnalyticsRow) => row.folderTitle,
    export: true,
  },
  {
    name: i18n.t('ColumnContent'),
    selector: (row: AnalyticsRow) => row.contentTitle,
    sortable: true,
    grow: 2,
    hide: screens.LG,
    cell: (row: AnalyticsRow) => {
      const iconMap = folderContentIcons as Record<string, string>;
      const icon = row.contentType ? iconMap[row.contentType] : '';
      if (!icon) return <span>{row.contentTitle}</span>;
      return (
        <span className="d-inline-flex align-items-center gap-1">
          <em className={`icon ${icon} mr-1`} />
          {row.contentTitle}
        </span>
      );
    },
    export: true,
  },
  {
    name: i18n.t('ColumnDateTime'),
    selector: (row: AnalyticsRow) => row.rawTime,
    sortable: true,
    cell: (row: AnalyticsRow) => row.dateTime,
    export: true,
    right: true,
  },
];

export default analyticsTableColumns;
